module.exports = __webpack_public_path__ + "static/img/huaxiafenmo.8935c79b.png";